<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cogs', fontSet: 'fad'}"
	[headerText]="T.PLAYER_MAPPING_CONFIGURATION_DIALOG_TITLE | translate: {playerMappingName: data.playerMapping.name}"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="row">
			<div class="col-lg-6 col-md-6 col-sm-6">
				<mat-form-field color="accent">
					<mat-label for="txtUsername">{{ T.MAPPING_CONFIGURATION_DIALOG_USERNAME | translate }}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.deviceUsername"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_USERNAME | translate"
						class="form-control"
						id="txtUsername"
						matInput
						type="text"
					/>
					<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_USERNAME_DESCRIPTION | translate }}</mat-hint>
				</mat-form-field>
				<mat-form-field color="accent">
					<mat-label for="txtPassword">{{ T.MAPPING_CONFIGURATION_DIALOG_PASSWORD | translate }}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.devicePassword"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_PASSWORD | translate"
						[type]="hidePassword ? 'password' : 'text'"
						class="form-control"
						id="txtPassword"
						matInput
					/>

					<button
						(click)="hidePassword = !hidePassword"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePassword"
						mat-icon-button
						matSuffix
					>
						@if (hidePassword) {
							<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
						}
						@if (!hidePassword) {
							<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
						}
					</button>
					<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_PASSWORD_DESCRIPTION | translate }}</mat-hint>
				</mat-form-field>

				<mat-form-field color="accent">
					<mat-label for="txtIpAddress">{{ T.MAPPING_CONFIGURATION_DIALOG_IP_ADDRESS | translate }}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.ip"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '192.168.89.30'}"
						class="form-control"
						id="txtIpAddress"
						matInput
						type="text"
					/>
				</mat-form-field>

				<mat-form-field color="accent">
					<mat-label for="txtSubnetMask">{{ T.MAPPING_CONFIGURATION_DIALOG_SUBNET_MASK | translate }}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.subnetMask"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '255.255.255.0'}"
						class="form-control"
						id="txtSubnetMask"
						matInput
						type="text"
					/>
				</mat-form-field>

				<mat-form-field color="accent">
					<mat-label>{{ T.MAPPING_CONFIGURATION_DIALOG_MAC_ADDRESS | translate }}</mat-label>
					<span matIconPrefix>
						<button
							(click)="findMacAddressForPlayer(data.playerMapping.ip); $event.stopPropagation()"
							(click)="findMacAddressForPlayer(data.playerMapping.ip)"
							appStopPropagation
							class="prefixBtn"
							color="accent"
						>
							<mat-icon fontSet="far" fontIcon="fa-search" inline />
						</button>
					</span>
					<input
						[(ngModel)]="data.playerMapping.macAddress"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '4C-ED-FB-91-62-F3'}"
						class="form-control"
						id="txtMacAddress"
						matInput
						type="text"
					/>
					<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_MAC_ADDRESS_DESCRIPTION | translate }}</mat-hint>
				</mat-form-field>
			</div>

			<div class="col-lg-6 col-md-6 col-sm-6">
				<mat-form-field color="accent">
					<mat-label for="txtConnectedMonitorIp">{{
						T.PLAYER_MAPPING_CONFIGURATION_DIALOG_CONNECTED_MONITOR_IP_ADDRESS | translate
					}}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.connectedMonitorIp"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '192.168.89.30'}"
						class="form-control"
						id="txtConnectedMonitorIp"
						matInput
						type="text"
					/>
				</mat-form-field>

				<mat-form-field color="accent">
					<mat-label>
						{{ T.PLAYER_MAPPING_CONFIGURATION_DIALOG_CONNECTED_MONITOR_MAC_ADDRESS | translate }}
					</mat-label>
					<span matIconPrefix>
						<button
							(click)="findMacAddressForConnectedMonitor(data.playerMapping.connectedMonitorIp)"
							appStopPropagation
							class="prefixBtn"
							color="accent"
							mat-icon-button
						>
							<mat-icon fontSet="far" fontIcon="fa-search" inline />
						</button>
					</span>
					<input
						[(ngModel)]="data.playerMapping.connectedMonitorMacAddress"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '4C-ED-FB-91-62-F3'}"
						class="form-control"
						id="txtConnectedMonitorMacAddress"
						matInput
						type="text"
					/>
				</mat-form-field>

				<mat-form-field color="accent">
					<mat-label for="txtBrowserTarget">{{ T.PLAYER_MAPPING_CONFIGURATION_DIALOG_BROWSER_TARGET | translate }}</mat-label>
					<input
						[(ngModel)]="data.playerMapping.browserTarget"
						[placeholder]="
							T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER
								| translate
									: {
											text: 'C:\\Program Files (x86)\\Google\\Chrome\\Application\\chrome.exe',
									  }
						"
						class="form-control"
						id="txtBrowserTarget"
						matInput
						type="text"
					/>
					<mat-hint>{{ T.PLAYER_MAPPING_CONFIGURATION_DIALOG_BROWSER_TARGET_DESCRIPTION | translate }}</mat-hint>
				</mat-form-field>

				<mat-checkbox [(ngModel)]="data.playerMapping.enableStreamingToMediaServer" id="cbEnableStreamingToMediaServer">
					<mat-label for="cbEnableStreamingToMediaServer">{{
						T.PLAYER_MAPPING_CONFIGURATION_DIALOG_ENABLE_STREAMING | translate
					}}</mat-label>
				</mat-checkbox>
			</div>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="saveForAll()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.PLAYER_MAPPING_CONFIGURATION_DIALOG_SAVE_FOR_ALL"
		/>
		<sim-button (onClick)="ok()" [color]="'accent'" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK" />
	</ng-container>
</sim-basic-material-dialog>
